import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
var THRESHOLD = 116;
var SHOW_MORE_CONTENT_SELECTOR = 'js-content-show-more';
var SHOW_MORE_SHOW_BUTTON_SELECTOR = 'js-btn-show';
var NAV_LIST_SELECTOR = 'o-nav-list__wrap-list';
export var isElementLowerThanThreshold = function isElementLowerThanThreshold() {
  var refererElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var threshold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : THRESHOLD;
  try {
    if (refererElement === null) throw 'All params for hideElementMoreThresholdHeight are mandatory';
    var refererElementHeight = refererElement ? refererElement.scrollHeight : 0;
    return refererElementHeight <= threshold;
  } catch (e) {
    throw "error : ".concat(e);
  }
};
export var hideElementMoreThresholdHeight = function hideElementMoreThresholdHeight() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  try {
    if (id === null) throw 'id of component is mandatory';
    var component = document.getElementById(id);
    var refererElement = component.querySelector(".".concat(SHOW_MORE_CONTENT_SELECTOR));
    var elementsToHide = component.querySelectorAll(".".concat(SHOW_MORE_SHOW_BUTTON_SELECTOR));
    var wrapperList = component.querySelector(".".concat(NAV_LIST_SELECTOR));
    if (refererElement && isElementLowerThanThreshold(refererElement) && elementsToHide) {
      elementsToHide.forEach(function (e) {
        e.classList.add('kl-hidden');
      });
      wrapperList.classList.add('o-nav-list__wrap-list--no-showmore');
      refererElement.classList.add('o-nav-list__description--no-showmore');
    }
  } catch (e) {
    throw "error : ".concat(e);
  }
};
export var disclosureToggleShowHide = function disclosureToggleShowHide() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  try {
    if (id === null) throw 'id of component is mandatory';
    var component = document.getElementById(id);
    var disclosureButtons = component.querySelectorAll(".".concat(SHOW_MORE_SHOW_BUTTON_SELECTOR));
    disclosureButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.target.closest(".".concat(NAV_LIST_SELECTOR)).classList.toggle("".concat(NAV_LIST_SELECTOR, "--open"));
        var expanded = e.target.getAttribute('aria-expanded');
        e.target.setAttribute('aria-expanded', "".concat(expanded === 'false' ? 'true' : 'false'));
      });
    });
  } catch (e) {
    throw "error : ".concat(e);
  }
};